import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { RoadProfileResponse, RoadProfileCreateRequest, RoadProfileUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { RoadProfileDetailsSectionHandler } from './details.section';
import { GeoFilterService } from 'app/services';

@RegisterEntityHandler('roadprofile')
@Injectable()
export class RoadProfileHandler extends EntityHandler<RoadProfileResponse> {

    constructor(
        admin: AdminEditorService,
        private filters: GeoFilterService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listRoadProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listRoadProfiles(ownerId, false, offset, limit, sort, filter), 3).then((response: EntityListResult) => ({
            ...response,
            type: 'roadprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ROADPROFILES'),
        }));
    }

    getEntity(id: string): Promise<RoadProfileResponse> {
        return this.admin.getCached(`getRoadProfile/${id}`, api => api.entities.getRoadProfile(id), 10);
    }

    createEntity(ownerId: string, entity: RoadProfileCreateRequest): Promise<RoadProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createRoadProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateRoadProfile(entity.id, { state: state as any }));
    }

    getGridIcon(_item: RoadProfileResponse): string {
        return ICONS.roadprofile;
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ROADPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<RoadProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new RoadProfileDetailsSectionHandler(this.admin, this.filters, ownerId, false),
            ].filter(x => x),
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: RoadProfileUpdateRequest, sections: FormSectionHandler<RoadProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'roadprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new RoadProfileDetailsSectionHandler(this.admin, this.filters, ownerId, true),
            ],
        });
    }

}












